import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { App, ConfigProvider } from "antd";
import MainApp from "./App";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ui/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00A693",
          fontFamily: '"Inter", sans-serif',
        },
        components: {
          Form: {
            itemMarginBottom: 12,
          },
        },
      }}
    >
      <App>
        <AuthProvider>
          <MainApp />
        </AuthProvider>
      </App>
    </ConfigProvider>
  </ErrorBoundary>
);

reportWebVitals();